export class Product {
    constructor(qonversionID, storeID, basePlanID, skuDetails, storeDetails, skProduct, offeringId, subscriptionPeriod, trialPeriod, type, prettyPrice, price, currencyCode, storeTitle, storeDescription, prettyIntroductoryPrice) {
        this.qonversionID = qonversionID;
        this.storeID = storeID;
        this.basePlanID = basePlanID;
        this.skuDetails = skuDetails;
        this.storeDetails = storeDetails;
        this.skProduct = skProduct;
        this.offeringId = offeringId;
        this.subscriptionPeriod = subscriptionPeriod;
        this.trialPeriod = trialPeriod;
        this.type = type;
        this.prettyPrice = prettyPrice;
        this.price = price;
        this.currencyCode = currencyCode;
        this.storeTitle = storeTitle;
        this.storeDescription = storeDescription;
        this.prettyIntroductoryPrice = prettyIntroductoryPrice;
    }
}
//# sourceMappingURL=Product.js.map